<template>
    <amf-form class="full-width">
        <div class="container-fluid ml-3">
        <div class="mt-2 row">
            <h2>FIRE</h2>
        </div>
        <div class="mt-2 row">
            <span class="amf-primitive three-column one">
                <label class="amf-input-label">File Type</label>
                <select class="form-control" v-model="formType">
                    <option value="1099">1099-SA (Distributions)</option>
                    <option value="5498">5498-SA (Contributions)</option>
                </select>
            </span>
        </div>
        <div class="mt-2 row">
            <amf-input label="Tax Year" v-model="taxYear" aggressive />
        </div>
        <div class="mt-2 row">
            <amf-input label="Employer ID (optional)" v-model="employerId" aggressive />
        </div>
        <div class="mt-2 row">
            <amf-button class="btn-default col-1" :onClick="calculate">Calculate {{ taxYear}} file </amf-button>
        </div>
        <br/>
        <template v-if="data">
            <div class="mt-2 row">
                Total Participants: {{ data.totalParticipants }}
                Total to be sent to IRS {{ data.numberOfReturns }}                
            </div>
            <div class="mt-2 row" v-if="data.numberOfReturns">
                <a href="#" @click.prevent="downloadReturnFile">Download File</a>
            </div>
            <div class="mt-1 mb-3 row" v-if="data.numberOfReturns">
                <div class="mt-2"><a href="#" @click.prevent="sendToParticpants">Send to Participants</a></div>                
            </div>
            <div class="mt-2 row">
                <div class="col">
                    <div class="mt-2 row">
                        <h5>Issuer (A Record, Box totals found in C record)</h5>
                        <table class="table table-condensed">
                            <thead>
                                <tr>
                                    <th>Issuer Name</th>
                                    <th>Type of Return</th>
                                    <th>Box 1 Total</th>
                                    <th>Box 2 Total</th>
                                    <th>Box 3 Total</th>
                                    <th>Box 4 Total</th>
                                    <th>Box 5 Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(issuer, index) in data.issuers" :key="index">
                                    <td>{{ issuer.firstIssuerNameLine }}</td>
                                    <td>{{ issuer.taxForm }} ( {{ issuer.typeOfReturn }})</td>
                                    <td>{{ issuer.controlTotal1 }}</td>
                                    <td>{{ issuer.controlTotal2 }}</td>
                                    <td>{{ issuer.controlTotal3 }}</td>
                                    <td>{{ issuer.controlTotal4 }}</td>
                                    <td>{{ issuer.controlTotal5 }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mt-2 row">
                        <h5>Payees (B Record)  {{ data.limit ? '*PREVIEW*' : '' }}</h5>
                        <table class="table table-condensed">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Account Number</th>
                                    <th>Type of Return</th>
                                    <th>Box 1</th>
                                    <th>Box 2</th>
                                    <th>Box 3</th>
                                    <th>Box 4</th>
                                    <th>Box 5</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(payee, index) in data.forms" :key="index">
                                    <td><router-link :to="`/participant/${payee.participantId}`" target="_blank">{{ payee.firstPayeeNameLine }}</router-link></td>
                                    <td>{{ payee.accountNumber }}</td>
                                    <td>{{ payee.taxForm }}</td>
                                    <td>{{ payee.amount1 }}</td>
                                    <td>{{ payee.amount2 }}</td>
                                    <td>{{ payee.amount3 }}</td>
                                    <td>{{ payee.amount4 }}</td>
                                    <td>{{ payee.amount5 }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col offset-1">
                    <div v-if="data && data.negatives.length" class="row mt-2">
                        <h5>Participants excluded due to negative amounts</h5>
                        <table class="table table-condensed">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Box 1</th>
                                    <th>Box 2</th>
                                    <th>Box 3</th>
                                    <th>Box 4</th>
                                    <th>Box 5</th>
                                </tr>
                            </thead>
                            <tbody v-for="(participant, index) in data.negatives" :key="index">
                                <tr>
                                    <td><router-link :to="`/participant/${participant.participantId}`" target="_blank">{{ participant.firstName }} {{ participant.lastName }}</router-link></td>
                                    <td>{{ participant.taxForm.box1 }}</td>
                                    <td>{{ participant.taxForm.box2 }}</td>
                                    <td>{{ participant.taxForm.box3 }}</td>
                                    <td>{{ participant.taxForm.box4 }}</td>
                                    <td>{{ participant.taxForm.box5 }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        </div>
    </amf-form>
</template>

<script>

    import Vue from 'vue';
    const correctionFlagOptions = [
        { id: 'true', name: 'With Correction Flag' },
        { id: 'false', name: 'Without Correction Flag' }
    ]

    export default {
        data() {
            return {
                employerId: null,
                participantId: null,
                taxYear: moment().year() - 1,
                formType: "1099",
                data: null,
                correctionFlag: 'false'
            }
        },
        watch: {
            employerId() {
                this.data = null;
            }
        },
        methods: {
            async askForFileCorrectionFlag() {
                var result = await modalService.select('Correction Flag', this.correctionFlag, [...correctionFlagOptions]);
                this.correctionFlag = result;
                return result;
            },
            async sendToParticpants() {
                let modalResponse = await modalService.show('send-to-participant', sendToParticipantComponent, {
                    correctionFlag: this.correctionFlag
                });
                
                if(!modalResponse) return;

                await romeApi.post(`hsa-tax-form/${this.taxYear}`, {
                    employerId: this.employerId,
                    participantId: this.participantId,
                    formType: this.formType,
                    createFile: modalResponse.createFile,
                    correction: modalResponse.correction,
                    sendEmail: modalResponse.sendEmail
                });

                toastService.success('Sent to participants');
            },
            async calculate() {
                let data = await romeApi.get(`hsa/irs-return-file/${this.formType}/preview?taxYear=${this.taxYear}&employerId=${this.employerId}`);
                this.data = data;
            },
            async downloadReturnFile() {
                var correction = await this.askForFileCorrectionFlag();
                await romeApi.download(`hsa/irs-return-file/${this.formType}?taxYear=${this.taxYear}&correction=${correction}&employerId=${this.employerId}`);
            }
        },
    }

    const sendToParticipantComponent = Vue.component('send-to-participants', {
        props: ['correctionFlag'],
        data() {
            return {
                correction: this.correctionFlag,
                correctionFlagOptions,
                sendEmail: false,
                createFile: true,
            }
        },
        methods: {
            async save() {
                return { ...this.$data };
            }
        },
        template: `
            <div class="container">
                <div class="row">
                    <amf-select label="Correction Flag" :columns="3" :options="correctionFlagOptions" v-model="correction" />
                </div>
                <div class="row mt-2">
                    <amf-checkbox label="Create File in Participant Portal" v-model="createFile" />
                </div>
                <div class="row mt-2">
                    <amf-checkbox label="Send Email" v-model="sendEmail" />
                </div>
            </div>
        `
    });
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/finance/HsaIrsReturnFile.vue